import { usePrevious } from 'hooks/usePrevious';
import { isEqual } from 'lodash';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

export const useScrollPosition = ({
  hasError,
  thread,
  isAsking,
  showDownload,
  files,
  isSessionExpired,
  isAgentTimeout,
}) => {
  const scrollableContainerRef = useRef<HTMLInputElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const prevError = usePrevious(hasError);

  const scroll = useMemo(() => {
    if (scrollableContainerRef?.current && !prevError && hasError) {
      return scrollableContainerRef.current.scrollTop;
    }
    return 0;
  }, [scrollableContainerRef, prevError, hasError]);

  useLayoutEffect(() => {
    if (scroll) {
      setScrollPosition(scroll);
    }
  }, [scroll]);

  useLayoutEffect(() => {
    if (
      thread ||
      isAsking ||
      showDownload ||
      files.length ||
      isSessionExpired ||
      isAgentTimeout
    ) {
      triggerScroll();
    }
  }, [
    thread,
    isAsking,
    showDownload,
    files.length,
    isSessionExpired,
    isAgentTimeout,
  ]);

  useEffect(() => {
    if (!isEqual(prevError, hasError) && !hasError) {
      scrollableContainerRef.current.scrollTop = scrollPosition;
    }
  }, [hasError]);

  const triggerScroll = () => {
    scrollableContainerRef.current.scrollTop =
      scrollableContainerRef.current.scrollHeight;
  };

  return { scrollableContainerRef, triggerScroll };
};
